import store from '@/store'
import { appInst } from '@/main'
// helpers
import dataGridUtils from '@/helpers/utils/methods/data-grid'
import eventBus from '@/helpers/event-bus'

export default {
  dataGrid_release(state) {
    state.models_dashboardModel = {}
    state.dataGrid_options = {}
    state.dgRowInEditMode = {}
    state.dgInEditMode = {}
  },
  dataGrid_setOptions(state, options) {
    state.dataGrid_options = options
  },
  dataGrid_onGridLogArrived(state, payload) {
    try {
      console.time('gridParse')

      const { gridId, chunk } = payload
      const updatedGrid = JSON.parse(payload.newVal)

      let grid = state.models_dashboardModel[gridId]

      if (!grid) {
        state.models_dashboardModel[gridId] = updatedGrid
      } else {
        state.models_dashboardModel[gridId] = Object.assign(
          state.models_dashboardModel[gridId],
          updatedGrid
        )
      }

      for (let rowKey in updatedGrid) {
        const row = updatedGrid[rowKey]

        store.commit('dataGrid_onRowLogArrived', {
          gridId,
          rowKey,
          id: row._id,
          newVal: JSON.stringify(row),
          delayParse: true,
        })
      }

      console.log('grid log arrived')
      if (!chunk) {
        console.log('parse all')
        parseAll(state)

        eventBus.$emit(`dgGridChanged-${gridId}`)
      }

      console.timeEnd('gridParse')
    } catch (err) {
      console.error(err)
    }
  },
  dataGrid_onRowLogArrived(state, payload) {
    const { gridId, rowKey, id, delayParse, notForAdmin } = payload

    if (notForAdmin && appInst.$can('all', 'Admin')) return

    let { newVal } = payload
    const dgOptions = state.dataGrid_options[gridId]

    if (!dgOptions) return
    if (!dgOptions.meta)
      throw new Error(`No columns defined for "${gridId}" DataGrid component`)

    if (newVal) {
      let grid = state.models_dashboardModel[gridId]

      if (!grid) return

      const rowData = Object.assign({ rowKey, _id: id }, { $count: 1 })

      try {
        const tmpNewVal = JSON.parse(newVal)

        if (tmpNewVal && tmpNewVal._created) rowData._created = true
      } catch (err) {}

      const meta = dgOptions.meta

      if (meta) {
        for (let cellKey in meta) {
          if (typeof rowData[cellKey] === 'undefined') rowData[cellKey] = null
        }
      }

      grid[rowKey] = Object.assign({}, rowData)

      let models = state.models_dashboardModel
      state.models_dashboardModel = Object.assign({}, models || {})

      if (!newVal) return

      try {
        newVal = JSON.parse(newVal)

        for (let cellKey in newVal) {
          if (
            cellKey === 'rowKey' ||
            cellKey === '_id' ||
            cellKey === '_created' ||
            !(cellKey in dgOptions.meta)
          )
            continue

          store.commit('dataGrid_onCellLogArrived', {
            gridId,
            rowKey,
            cellKey,
            newVal: newVal[cellKey],
            delayParse,
          })
        }

        if (!delayParse) {
          for (let cellKey in newVal) {
            if (cellKey === 'rowKey' || !(cellKey in dgOptions.meta)) continue

            parseCell({ state, gridId, rowKey, cellKey })
          }

          eventBus.$emit(`dgRowChanged-${gridId}`, rowKey)
        }
      } catch (err) {
        console.error(err)
      }
    } else {
      let grid = state.models_dashboardModel[gridId]

      if (!grid) return

      delete grid[rowKey]

      let models = state.models_dashboardModel
      state.models_dashboardModel = Object.assign({}, models || {})

      eventBus.$emit(`dgRowChanged-${gridId}`, rowKey)
    }
  },
  async dataGrid_onCellLogArrived(state, payload) {
    const { gridId, rowKey, cellKey, newVal, cb, delayParse } = payload
    const dgOptions = state.dataGrid_options[gridId]

    if (!dgOptions) return
    if (!dgOptions.meta)
      throw new Error(`No columns defined for "${gridId}" DataGrid component`)

    if (typeof newVal !== 'undefined') {
      let grid = state.models_dashboardModel[gridId]

      if (!grid) return
      if (!grid[rowKey]) return

      grid[rowKey][cellKey] = newVal
    } else {
      let grid = state.models_dashboardModel[gridId]

      if (!grid) return
      if (!grid[rowKey]) return

      delete grid[rowKey][cellKey]
    }

    state.models_dashboardModel = Object.assign(
      {},
      state.models_dashboardModel || {}
    )

    if (!cb) {
      if (!delayParse) {
        parseCell({ state, gridId, rowKey, cellKey })

        eventBus.$emit('dgCellChanged', gridId, rowKey, cellKey, newVal)
        eventBus.$emit(`dgRowChanged-${gridId}`, rowKey)
      }
    } else {
      dgOptions.displayColumn === cellKey ? cb(true) : cb()
    }
  },
  dataGrid_setLogsValue(state, value) {
    state.dataGridLogsValue = value
  },
  toggleDGRowEditMode(state, key) {
    const a = Object.assign({}, state.dgRowInEditMode)
    if (state.dgRowInEditMode[key]) delete a[key]
    else a[key] = true
    state.dgRowInEditMode = a
  },
  toggleDGEditMode(state, key) {
    const a = Object.assign({}, state.dgInEditMode)
    if (state.dgInEditMode[key]) {
      delete a[key]
      this.commit('clearDGRowEditMode', key)
    } else a[key] = true
    state.dgInEditMode = a
  },
  clearDGRowEditMode(state, grid) {
    if (grid) {
      const a = Object.assign({}, state.dgRowInEditMode)
      const b = {}

      for (let key in a) {
        const g = key.slice(0, key.indexOf('.'))
        if (g === grid) continue
        b[key] = true
      }

      state.dgRowInEditMode = b
    } else {
      state.dgRowInEditMode = {}
    }
  },
  setDGEditRowModalShown(state, gridId) {
    const o = Object.assign({}, state.dgEditRowModalsShown)
    o[gridId] = true
    state.dgEditRowModalsShown = o
  },
  setDGEditRowModalHidden(state, gridId) {
    const o = Object.assign({}, state.dgEditRowModalsShown)
    delete o[gridId]
    state.dgEditRowModalsShown = o
  },
  resleaseDGEditRowOpened(state) {
    state.dgEditRowModalsShown = {}
  },
  setDGAddControlInProcess(state, { gridId, status }) {
    const o = Object.assign({}, state.dgAddControlInProcess)
    if (status) o[gridId] = true
    else delete o[gridId]
    state.dgAddControlInProcess = o
  },
  releaseDGAddControlInProcess(state) {
    state.dgAddControlInProcess = {}
  },
  dataGrid_setFilterBuilder(state, { widgetKey, filter }) {
    state.dataGrid_filterBuilders = Object.assign(
      state.dataGrid_filterBuilders,
      { [widgetKey]: filter }
    )
  },
  dataGrid_releaseFilterBuilders(state) {
    state.dataGrid_filterBuilders = {}
  },
}

function parseAll(state) {
  dataGridUtils.dataGridParse(state)
}

function parseCell(payload) {
  const { state, gridId, rowKey, cellKey } = payload
  const allOptions = state.dataGrid_options
  const dgOptions = state.dataGrid_options[gridId]
  const data = {
    state,
    gridId,
    rowKey,
    cellKey,
    dgOptions,
    allOptions,
  }

  switch (dgOptions.meta[cellKey].type) {
    case 'lookup':
      try {
        dataGridUtils.insertCellLookUpExtraData(data)
      } catch (err) {
        console.error(
          `[DataGrid parser:insertCellLookUpExtraData] grid: "${gridId}", cellKey: "${cellKey}", message: "${err.message}"`
        )
      }
      break
    case 'multi_lookup':
      try {
        dataGridUtils.insertCellMultiLookUpExtraData(data)
      } catch (err) {
        console.error(
          `[DataGrid parser:insertCellMultiLookUpExtraData] grid: "${gridId}", cellKey: "${cellKey}", message: "${err.message}"`
        )
      }
      break
    case 'user':
      try {
        dataGridUtils.insertCellUserExtraData(data)
      } catch (err) {
        console.error(
          `[DataGrid parser:insertCellUserExtraData] grid: "${gridId}", cellKey: "${cellKey}", message: "${err.message}"`
        )
      }
      break
    case 'date':
      try {
        dataGridUtils.insertCellDateExtraData(data)
      } catch (err) {
        console.error(
          `[DataGrid parser:insertCellDateExtraData] grid: "${gridId}", cellKey: "${cellKey}", message: "${err.message}"`
        )
      }
      break
    case 'files':
      try {
        dataGridUtils.insertCellFilesExtraData(data)
      } catch (err) {
        console.error(
          `[DataGrid parser:insertCellFilesExtraData] grid: "${gridId}", cellKey: "${cellKey}", message: "${err.message}"`
        )
      }
      break
  }
}
